import type { DataTableColumn } from '@wundo/ui';
import type { UsageCostTotals } from '@/lib/usageCost.ts';
import { CostTableCard } from './CostTableCard.tsx';
import { formatTokens, share } from './costFormat.ts';

interface TokenRow {
  label: string;
  value: number;
}

/** Which kinds of tokens the window's model calls were made of. */
export function TokenMixCard({ totals }: { totals: UsageCostTotals }) {
  const rows: TokenRow[] = [
    { label: 'Input (fresh)', value: totals.input_tokens },
    { label: 'Output', value: totals.output_tokens },
    { label: 'Cache read', value: totals.cache_read_tokens },
    { label: 'Cache write 5m', value: totals.cache_creation_5m_tokens },
    { label: 'Cache write 1h', value: totals.cache_creation_1h_tokens },
    { label: 'Reasoning', value: totals.reasoning_output_tokens },
  ].filter((row) => row.value > 0);
  const tokenTotal = rows.reduce((sum, row) => sum + row.value, 0);

  const columns: DataTableColumn<TokenRow>[] = [
    { key: 'label', header: 'Tokens' },
    {
      key: 'value',
      header: 'Count',
      align: 'end',
      nowrap: true,
      render: (row) => formatTokens(row.value),
    },
    {
      key: 'share',
      header: 'Share',
      align: 'end',
      nowrap: true,
      render: (row) => share(row.value, tokenTotal),
    },
  ];

  return (
    <CostTableCard<TokenRow>
      title='Token mix'
      label='Token mix'
      columns={columns}
      rows={rows}
      rowKey={(row) => row.label}
    />
  );
}
